import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * The suggestion list under a free-text clinical field, fetched once per
 * list and shared across the rows that use it. A failure leaves the field
 * as plain text — the list is a convenience, never a gate.
 */
const cache = new Map<string, Promise<string[]>>();

export function useSuggestions(list: string | null): string[] {
  const [items, setItems] = useState<string[]>([]);
  useEffect(() => {
    if (!list) return;
    if (!cache.has(list)) {
      cache.set(list, api.get<Array<{ text: string }>>(`/clinical-suggestions?list=${encodeURIComponent(list)}&limit=200`)
        .then((rows) => rows.map((r) => r.text))
        .catch(() => { cache.delete(list); return []; }));
    }
    let live = true;
    void cache.get(list)!.then((rows) => { if (live) setItems(rows); });
    return () => { live = false; };
  }, [list]);
  return items;
}

/** Forget a list so the next field asks again — after an administrator edits it. */
export function forgetSuggestions(list?: string) {
  if (list) cache.delete(list); else cache.clear();
}
